import React from 'react';
import styled from 'styled-components';

const variantMapper = (theme: any) => ({
  default: {
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: 'unset',
    color: 'inherit',
    imgFilter: 'none',
  },
  'square-primary': {
    backgroundColor: theme.primary.primary,
    border: 'none',
    borderRadius: '8px',
    color: 'white',
    imgFilter: 'brightness(0) invert(1)',
  },
  'square-secondary': {
    backgroundColor: theme.text.primary,
    border: `1px solid ${theme.border.primary}`,
    borderRadius: '8px',
    color: theme.text.regular,
    imgFilter: 'brightness(0)',
  },
  white: {
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: 'unset',
    color: 'white',
    imgFilter: 'brightness(0) invert(1)',
  },
});

const StyledIconButton = styled.button<{ variant?: string }>`
  background-color: ${({ variant = 'default', theme }) =>
    variantMapper[variant]?.backgroundColor ||
    variantMapper(theme)[variant]?.backgroundColor ||
    variantMapper(theme).default.backgroundColor};
  border: ${({ variant = 'default', theme }) =>
    variantMapper[variant]?.border ||
    variantMapper(theme)[variant]?.border ||
    variantMapper(theme).default.border};
  border-radius: ${({ variant = 'default', theme }) =>
    variantMapper[variant]?.borderRadius ||
    variantMapper(theme)[variant]?.borderRadius ||
    variantMapper(theme).default.borderRadius};
  color: ${({ variant = 'default', theme }) =>
    variantMapper[variant]?.color ||
    variantMapper(theme)[variant]?.color ||
    variantMapper(theme).default.color};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 9px;

  img {
    filter: ${({ variant = 'default', theme }) =>
      variantMapper[variant]?.imgFilter ||
      variantMapper(theme)[variant]?.imgFilter ||
      variantMapper(theme).default.imgFilter};
  }
`;

interface IconButtonProps {
  children: React.ReactNode;
  iconUrl: string;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  variant?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  as?: React.ElementType;
  [key: string]: any;
}

const IconButton: React.FC<IconButtonProps> = ({
  children,
  iconUrl,
  onClick = () => {},
  type = 'button',
  variant,
  disabled = false,
  style = {},
  as,
  imageStyle = {},
  ...props
}) => {
  return (
    <StyledIconButton
      as={as}
      variant={variant}
      disabled={disabled}
      onClick={onClick}
      style={style}
      {...props}
    >
      {typeof iconUrl === 'string' ? (
        <img src={iconUrl} alt='icon' style={imageStyle} />
      ) : (
        iconUrl
      )}
      {children}
    </StyledIconButton>
  );
};

export default IconButton;
